import React, { memo, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Container,
  // UncontrolledAlert,
  ButtonToolbar,
  Spinner,
  Alert
} from "reactstrap";
import { MdArrowBack, MdVerticalAlignBottom } from "react-icons/md";
import { connect } from "react-redux";
import validate from "./validate";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField } from "../../../../utils/renderfield";
import { Link } from "react-router-dom";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderRadioButtonField from "../../../../shared/components/form/RadioButton";
import PageHeader from "../../../../shared/components/PageHeader";

const DisbursementForm = memo(
  ({
    reset,
    disbursementType,
    pristine,
    id,
    loading,
    fileUrl,
    invalid,
    handleSubmit,
    submitting,
    csvFileValue,
    postDisbursement,
  }) => {

    return (
      <Container>
        <Col>
          <PageHeader
            header="Create Disbursement"
            subheader="Create new disbursement"
            header={`${id ? "Edit" : "Add"} Disbursement`}
            subheader={`${id ? "Update Disbursement" : "Create new Disbursement"}`}
          />
        </Col>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">
                  <Link to="/disbursement" id="link-all-users">
                    <MdArrowBack size={20} /> Back to Disbursement Table
                  </Link>
                </h5>
              </div>
              {
                loading ? 
                <div className="text-center">
                  <div>
                      <Spinner
                          color="success"
                          className="my-4"
                          style={{ width: "6rem", height: "6rem" }}
                      />
                      <h4 className="text-secondary">{`Fetching disbursement with id - ${id}`}</h4>
                    
                  </div>
                </div> 
              :
              <form className="form" onSubmit={handleSubmit}>
                <Col lg={{ size: 8, offset: 3 }}>
                  <Row>
                    <Col lg="8">
                      <h4 className="form__form-group-label bold-text">
                        Enter disbursement details below.
                      </h4>
                      <br />
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8">
                      <div className="form__form-group">
                        <span className="form__form-group-label bold-text">
                          Name of Disbursement
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            id="nameOfDisbursement"
                            name="nameOfDisbursement"
                            component={renderField}
                            type="text"
                            placeholder=""
                            required
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8">
                      <div className="form__form-group">
                        <span className="form__form-group-label bold-text">
                          Total Amount
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            id="amount"
                            name="amount"
                            component={renderField}
                            type="number"
                            required
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8">
                      <div className="form__form-group">
                        <span className="form__form-group-label bold-text">
                          Number of Recipients
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            id="numberOfRecipients"
                            name="numberOfRecipients"
                            component={renderField}
                            type="number"
                            required
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                 
                  <Row>
                    <Col lg="8">
                      <div className="form__form-group">
                        <span className="form__form-group-label bold-text">
                          Select Instant or scheduled Disbursement
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="disbursementType"
                            component={renderRadioButtonField}
                            label="Instant"
                            radioValue="INSTANT"
                            defaultChecked
                          />
                          <Field
                            name="disbursementType"
                            component={renderRadioButtonField}
                            label="Scheduled"
                            radioValue="SCHEDULED"
                          />
                        </div>
                      </div>
                      {disbursementType === "SCHEDULED" && (
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <Field
                              id="scheduledDate"
                              name="scheduledDate"
                              component={renderField}
                              type="datetime-local"
                            />
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8">
                      <div className="randomiserflexcontainer randomiserspacebetween">
                        <span className="form__form-group-label"></span>
                        <span>
                          { !fileUrl ?
                            <a
                              target="blank"
                              href={
                                "https://mufasa.interswitchng.com/p/bulkpaycodeapi/templates/disbursement-template.csv"
                              }
                            >
                              <MdVerticalAlignBottom />
                              &nbsp; Download Disbursement Template to input
                              details
                              <br />
                              <br />
                            </a> :
                            <a
                            target="blank"
                            href={fileUrl}
                          >
                            <MdVerticalAlignBottom />
                            &nbsp; Download File Attached
                            <br />
                            <br />
                          </a>
                          
                          }
                        </span>
                      </div>
                      <section>
                        <Alert
                          color="info"
                          style={{
                            height: "5.5rem",
                            border: "2px dotted #449dcf",
                          }}
                        >
                          <div
                            className="form__form-group"
                            style={{ textAlign: "center" }}
                          >
                            <div className="form__form-group-field bold-text">
                              <Field
                                id="csv_file"
                                name="csv_file"
                                component={renderFileInputField}
                                anchorText="Browse files"
                                accept=".csv"
                                required
                              />
                            </div>
                            {csvFileValue ? (
                              ""
                            ) : (
                              <small>Accepted file format .CSV</small>
                            )}
                          </div>
                        </Alert>
                      </section>
                    </Col>
                  </Row>
                  <ButtonToolbar className="form__button-toolbar">
                    <Button
                      type="button"
                      id="reset-form"
                      onClick={reset}
                      disabled={false}
                    >
                      {" "}
                      {/*  || pristine || submitting */}
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      id="submit-btn"
                      type="submit"
                      disabled={pristine || submitting || invalid}
                    >
                      {postDisbursement.loading && (
                        <span>
                          <Spinner size="sm" color="default" />{" "}
                        </span>
                      )}
                      Save
                    </Button>
                  </ButtonToolbar>
                </Col>
              </form>
              }
            </CardBody>
          </Card>
        </Col>
      </Container>
    );
  }
);

const selector = formValueSelector("disbursement_form");
export default reduxForm({
  form: "disbursement_form",
  validate,
  enableReinitialize: true,
})(
  connect((state) => ({
    postuser: state.postuser,
    permissions: state.permissions && state.permissions.response,
    csvFileValue: selector(state, "csv_file"),
    disbursementType: selector(state, "disbursementType"),
  }))(DisbursementForm)
);
